<template>
  <BaseField
    baseRule="student_password"
    v-bind="$attrs"
    :label="label"
    :type="showPassword ? 'text' : 'password'"
    :placeholder="placeholder"
    v-model="inputValue"
  >
    <template v-slot:feedback="slotProps">
      <div class="checkbox form-check-inline line-break">
        <input type="checkbox" class="form-check-input" :id="label" v-model="showPassword" />
        <label class="form-check-input" :for="label">パスワードを表示する</label>
        <div class="invalid-feedback" v-show="slotProps.invalid">{{ slotProps.errors[0] }}</div>
      </div>
    </template>
  </BaseField>
</template>

<script>
import BaseField from '@/components/forms/BaseField.vue';

export default {
  data() {
    return {
      showPassword: false,
    };
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'パスワード',
    },
    placeholder: {
      type: String,
      default: '数字と英字を最低１つ含む４文字以上で入力してください',
    },
  },
  components: {
    BaseField,
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style scoped>
.line-break {
  width: 100%;
}
.invalid-feedback {
  font-size: 1px;
}
</style>
